/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function defaultCurrencyDeriver(
  ctrl: any,
  localUserProfile: any,
  deferApply?: (fn: () => void) => void
): (advertiser: any, team: any, product: any) => void {
  const defaultCurrencies: Record<string, string> = {};
  ctrl.updateCurrencyHook = {};

  return function(advertiser, team, product) {
    const advertiserCurrency = _.get(advertiser, 'defaultCurrency');
    const teamCurrency = _.get(team, 'defaultCurrency');
    const productCurrency = _.get(product, ['minimumBudget', 'currency']) || _.get(product, ['maximumBudget', 'currency']) || _.get(product, ['minimumCpm', 'currency']) || _.get(product, ['maximumBudget', 'currency']);
    const preferredCurrency = localUserProfile.getPreferredCurrency();

    defaultCurrencies.ADVERTISER = defaultCurrencies.ADVERTISER || advertiserCurrency;
    defaultCurrencies.TEAM = defaultCurrencies.TEAM || teamCurrency;
    defaultCurrencies.PRODUCT = defaultCurrencies.PRODUCT || productCurrency;

    const nextCurrency = defaultCurrencies.ADVERTISER || defaultCurrencies.TEAM || defaultCurrencies.PRODUCT || preferredCurrency;
    if (nextCurrency === ctrl.moneyCurrency && nextCurrency === ctrl.chartCurrency) {
      return;
    }

    const apply = () => {
      ctrl.moneyCurrency = nextCurrency;
      ctrl.chartCurrency = nextCurrency;
      if (_.isFunction(ctrl.updateCurrencyHook.update)) {
        ctrl.updateCurrencyHook.update(ctrl.moneyCurrency);
      }
    };

    // Defer — [defaultCurrency]="moneyCurrency" on adn-money-field NG0100s when
    // hydrate flips undefined→NOK (etc.) mid-CD.
    if (deferApply) {
      deferApply(apply);
    } else {
      apply();
    }
  };
}
